exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\n  line-height: 30px;\n  color: #efefef;\n  text-align: center;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  height: 30px;\n  width: 100%;\n  background: #007eca;\n  box-shadow: 0 0 6px 1px black; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/footer/footer.style.scss
// module id = ../../../../../src/app/components/footer/footer.style.scss
// module chunks = main